import type { IdleDisplay, SyncIntervalSeconds } from '@ghostscreen/contracts';

export const SETTINGS_TIMEZONES = [
  'Europe/London',
  'Europe/Dublin',
  'Europe/Paris',
  'America/New_York',
  'America/Los_Angeles',
  'Asia/Dubai',
  'Australia/Sydney',
] as const;

/** Labels live in the `settings` namespace under `syncInterval.options.<value>`. */
export const SYNC_INTERVAL_VALUES: readonly SyncIntervalSeconds[] = [30, 60, 300];

/** Labels live in the `settings` namespace under `idleDisplay.options.<value>`. */
export const IDLE_DISPLAY_VALUES: readonly IdleDisplay[] = ['logo', 'clock', 'black'];
